import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Только Django staff или флаг is_admin на профиле. */
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.is_staff && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
